import { CommonModule, NgOptimizedImage } from '@angular/common';
import { NgModule } from '@angular/core';

import { TrustPipe } from '@frontend/sports/common/core/utils/dom';
import { CompetitionLogoComponent } from '@frontend/sports/competition-logos/feature';
import { ItemComponent } from '@frontend/sports/item/feature';
import { PriceboostCountSignpostComponent } from '@frontend/sports/price-boost/feature';
import { IconCustomComponent } from '@frontend/vanilla/shared/icons';

import { WidgetHeaderComponent } from './widget-header.component';
import { WidgetTabBarComponent } from './widget-tab-bar.component';

@NgModule({
    imports: [
        WidgetTabBarComponent,
        CommonModule,
        CompetitionLogoComponent,
        PriceboostCountSignpostComponent,
        ItemComponent,
        TrustPipe,
        IconCustomComponent,
        NgOptimizedImage,
    ],
    exports: [WidgetTabBarComponent, WidgetHeaderComponent],
    declarations: [WidgetHeaderComponent],
})
export class WidgetCommonModule {}
